<!-- Pagination.vue -->
<template>
  <div class="pagination">
    <TxBtn
      @click="prevPage"
      :disabled="props.page === 1"
      src="rank_fanye-zuo"
      name="上一页"
    />

    <TxBtn @click="goToPage(1)" name="首页" src="rank_yema-shouweiye"
      >首页</TxBtn
    >

    <TxBtn
      v-for="_page in displayedPages"
      :key="_page"
      @click="goToPage(_page)"
      src="rank_yema-weixuanzhong"
      :name="`页码-${_page}`"
      :class="{ active: props.page === _page }"
      >{{ _page }}</TxBtn
    >

    <TxBtn @click="goToPage(totalPages)" name="尾页" src="rank_yema-shouweiye"
      >尾页</TxBtn
    >
    <TxBtn
      @click="nextPage"
      :disabled="props.page === totalPages"
      src="rank_fanye-you"
      name="下一页"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  total: {
    type: Number,
    required: true,
  },
  size: {
    type: Number,
    default: 10,
  },
  page: {
    type: Number,
    default: 1,
  },
});

const emit = defineEmits(['update:page', 'pageChange']);

const totalPages = computed(() =>
  Math.ceil(props.total / props.size)
);

const displayedPages = computed(() => {
  const range = 5; // 显示当前页附近的5个页码
  let start = Math.max(1, props.page - Math.floor(range / 2));
  let end = Math.min(totalPages.value, start + range - 1);

  if (end - start + 1 < range) {
    start = Math.max(1, end - range + 1);
  }

  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
});

const prevPage = () => {
  if (props.page > 1) {
    emit('update:page', props.page - 1);
    emit('pageChange', props.page - 1);
  }
};

const nextPage = () => {
  if (props.page < totalPages.value) {
    emit('update:page', props.page + 1);
    emit('pageChange', props.page + 1);
  }
};

const goToPage = (page) => {
  console.log('goToPage', page);
  if (page >= 1 && page <= totalPages.value && page != props.page) {
    emit('update:page', page);
    emit('pageChange', page);
  }
};

</script>

<style scoped>
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -20px;
  z-index: 1;
}

.pagination button {
  cursor: pointer;
  color: #eee;
}

.pagination button.active {
  color: #ff0;
}

.pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>